{
  "note": "Known national and annual campaigns. Rules generate the dates for any year; confirmed entries override a rule for one year. Rules marked estimate follow the pattern of recent years and should be checked each year. Draft values may use the tokens listed in docs/CAMPAIGNS.md. Run npm run docs after editing.",
  "categories": [
    { "id": "camra", "label": "CAMRA campaigns and dates", "phrase": "CAMRA campaigns and dates", "defaultOn": true },
    { "id": "beer", "label": "Beer and pub days", "phrase": "beer and pub days", "defaultOn": true },
    { "id": "national", "label": "National days", "phrase": "national days", "defaultOn": false }
  ],
  "campaigns": [
    {
      "id": "mild-month",
      "name": "Mild Month",
      "category": "camra",
      "summary": "CAMRA's month-long celebration of mild every May: make yours a Mild this May. Branches run mild trails and pubs put a mild on the bar.",
      "url": "https://camra.org.uk/promotional-campaigns",
      "hashtags": ["#MildMay", "#MildMonth"],
      "rule": { "kind": "month", "month": 5 },
      "leadDays": 28,
      "drafts": [
        { "id": "countdown", "name": "Countdown", "phase": "before", "type": "campaignmonth", "icon": "beer", "values": { "campaignName": "Mild Month", "phase": "countdown", "days": "{days}", "dates": "{dates}", "note": "Make yours a Mild this May." } },
        { "id": "on-now", "name": "It's here", "phase": "start", "type": "campaignmonth", "icon": "beer", "values": { "campaignName": "Mild Month", "phase": "now", "heading": "Make yours a Mild this May", "dates": "{dates}", "note": "Ask for a mild at the bar all month.", "pubs": [{ "pub": "Pub name", "detail": "Which mild is on" }, { "pub": "Pub name", "detail": "Which mild is on" }] } },
        { "id": "last-week", "name": "Last week", "phase": "end", "type": "campaignmonth", "icon": "beer", "values": { "campaignName": "Mild Month", "phase": "last", "heading": "Last week of Mild Month", "note": "There is still time to make yours a mild." } },
        { "id": "thanks", "name": "Thank you", "phase": "after", "type": "campaignmonth", "icon": "heart", "values": { "campaignName": "Mild Month", "phase": "thanks", "heading": "Thanks for drinking mild", "note": "Thank you to every pub that put a mild on the bar this May." } }
      ]
    },
    {
      "id": "cider-perry-month",
      "name": "Cider and Perry Month",
      "category": "camra",
      "summary": "CAMRA's month-long celebration of real cider and perry, held every July since 2025 (it used to run in May and October). Ask for #NotFromConcentrate real cider or perry.",
      "url": "https://camra.org.uk/promotional-campaigns/cider-and-perry-months",
      "hashtags": ["#CiderandPerryMonth", "#NotFromConcentrate"],
      "rule": { "kind": "month", "month": 7 },
      "leadDays": 28,
      "drafts": [
        { "id": "countdown", "name": "Countdown", "phase": "before", "type": "campaignmonth", "icon": "apple", "values": { "campaignName": "Cider and Perry Month", "phase": "countdown", "days": "{days}", "dates": "{dates}", "note": "A month of real cider and perry at your local." } },
        { "id": "on-now", "name": "It's here", "phase": "start", "type": "campaignmonth", "icon": "apple", "values": { "campaignName": "Cider and Perry Month", "phase": "now", "heading": "Cider and Perry Month", "dates": "{dates}", "note": "Ask for #NotFromConcentrate real cider or perry at the bar.", "pubs": [{ "pub": "Pub name", "detail": "Ciders and perries on" }, { "pub": "Pub name", "detail": "Ciders and perries on" }] } },
        { "id": "last-week", "name": "Last week", "phase": "end", "type": "campaignmonth", "icon": "pear", "values": { "campaignName": "Cider and Perry Month", "phase": "last", "heading": "Last week of Cider and Perry Month", "note": "There is still time to try a real cider or perry." } },
        { "id": "thanks", "name": "Thank you", "phase": "after", "type": "campaignmonth", "icon": "heart", "values": { "campaignName": "Cider and Perry Month", "phase": "thanks", "heading": "Thanks for a month of real cider", "note": "Thank you to every pub and producer who joined in this July." } }
      ]
    },
    {
      "id": "gbg-launch",
      "name": "Good Beer Guide launch",
      "category": "camra",
      "summary": "Publication day for the next edition of CAMRA's Good Beer Guide, usually a Thursday in late September. Branches hold launch events and celebrate the pubs that made it in.",
      "url": "https://camra.org.uk/good-beer-guide",
      "hashtags": ["#GoodBeerGuide", "#GBG{edition}"],
      "rule": { "kind": "nthWeekday", "month": 9, "weekday": 4, "n": 4, "days": 1, "estimate": true },
      "confirmed": {
        "2025": { "start": "2025-09-25", "end": "2025-09-25" },
        "2026": { "start": "2026-09-24", "end": "2026-09-24" }
      },
      "leadDays": 28,
      "drafts": [
        { "id": "countdown", "name": "Countdown", "phase": "before", "type": "countdown", "icon": "book-open", "values": { "event": "The {edition} Good Beer Guide", "days": "{days}", "date": "Out {start}" } },
        { "id": "launch-event", "name": "Launch event", "phase": "before", "type": "announcement", "icon": "book-open", "values": { "heading": "Good Beer Guide {edition} launch", "body": "Join us on {start} to celebrate the new Guide.\nPick up a copy and raise a glass to the pubs that made it in." } },
        { "id": "in-the-guide", "name": "Our pubs in the Guide", "phase": "start", "type": "gbg", "icon": "book-open", "values": { "heading": "In the {edition} Good Beer Guide", "edition": "Out now", "pubs": [{ "pub": "Pub name", "town": "Town" }, { "pub": "Pub name", "town": "Town" }, { "pub": "Pub name", "town": "Town" }] } }
      ]
    },
    {
      "id": "members-weekend",
      "name": "CAMRA Members' Weekend and AGM",
      "category": "camra",
      "summary": "CAMRA's annual gathering in April: the AGM, Conference, National Executive election results and the Members' Bar, in a different host city each year.",
      "url": "https://camra.org.uk/members-weekend",
      "hashtags": ["#CAMRAMembersWeekend"],
      "rule": { "kind": "nthWeekday", "month": 4, "weekday": 5, "n": 3, "days": 3, "estimate": true },
      "confirmed": {
        "2026": { "start": "2026-04-17", "end": "2026-04-19", "venue": "St Albans" },
        "2027": { "start": "2027-04-16", "end": "2027-04-18", "venue": "Chester" }
      },
      "leadDays": 42,
      "drafts": [
        { "id": "countdown", "name": "Countdown", "phase": "before", "type": "countdown", "icon": "users", "values": { "event": "CAMRA Members' Weekend {where}", "days": "{days}", "date": "{dates}" } },
        { "id": "see-you-there", "name": "See you there", "phase": "before", "type": "announcement", "icon": "users", "values": { "heading": "See you at Members' Weekend", "body": "{dates} {where}.\nThe AGM, Conference and the Members' Bar." } }
      ]
    },
    {
      "id": "camra-birthday",
      "name": "CAMRA's birthday",
      "category": "camra",
      "summary": "CAMRA was founded on 16 March 1971. A good excuse to thank members and invite new ones.",
      "hashtags": ["#CAMRA"],
      "rule": { "kind": "fixed", "month": 3, "day": 16 },
      "leadDays": 14,
      "drafts": [
        { "id": "birthday", "name": "Happy birthday", "phase": "start", "type": "occasion", "icon": "party-popper", "values": { "occasion": "CAMRA's birthday", "phase": "today", "heading": "Happy {ordinal} birthday, CAMRA", "note": "Campaigning for pubs, pints and people since 16 March 1971." } },
        { "id": "join", "name": "Join us", "phase": "start", "type": "join", "icon": "user-plus", "values": { "heading": "Join the campaign", "benefits": [{ "benefit": "{age} years of campaigning", "detail": "for pubs, pints and people" }, { "benefit": "Free or discounted entry", "detail": "to CAMRA beer festivals" }, { "benefit": "Have your say", "detail": "on the pubs and beers we champion" }], "link": "camra.org.uk/join" } }
      ]
    },
    {
      "id": "volunteers-week",
      "name": "Volunteers' Week",
      "category": "camra",
      "summary": "The UK's celebration of volunteering, the first week of June. CAMRA is run by its volunteers, so it is the week to thank yours and invite new ones.",
      "url": "https://camra.org.uk/volunteer",
      "hashtags": ["#VolunteersWeek", "#CAMRA"],
      "rule": { "kind": "nthWeekday", "month": 6, "weekday": 1, "n": 1, "days": 7, "estimate": true },
      "confirmed": {
        "2026": { "start": "2026-06-01", "end": "2026-06-07" }
      },
      "leadDays": 21,
      "drafts": [
        { "id": "thank-you", "name": "Thank you", "phase": "start", "type": "occasion", "icon": "hand-heart", "values": { "occasion": "Volunteers' Week", "phase": "now", "heading": "Thank you, volunteers", "dates": "{dates}", "note": "Every festival, pub survey and campaign we run happens because of you.", "copy": "👏 It's #VolunteersWeek, so let's celebrate the brilliant people who make our branch tick!\n\n🙋 Saving pubs, pulling pints at festivals, surveying pubs and scoring beers: our volunteers make CAMRA the force it is.\n\n🍻 Thank you. What's your favourite part of volunteering with us?\n\n#VolunteersWeek #CAMRA" } },
        { "id": "get-involved", "name": "Get involved", "phase": "start", "type": "volunteers", "icon": "users", "values": { "heading": "Fancy getting involved?", "event": "Volunteers' Week, {dates}", "roles": [{ "role": "Beer festival crew", "when": "Set up, bar and take down" }, { "role": "Pub surveys and beer scoring", "when": "Whenever you're at the pub" }, { "role": "Campaigning", "when": "Helping keep local pubs open" }], "contact": "camra.org.uk/volunteer", "copy": "🙋 Ever thought about volunteering with CAMRA? #VolunteersWeek is the perfect time to start.\n\n🍺 Help at a beer festival, score the beers in your local or campaign to keep pubs open. Give as much or as little time as you like.\n\n➡️ Find out more at camra.org.uk/volunteer, or say hello at our next branch social.\n\n#VolunteersWeek #CAMRA" } }
      ]
    },
    {
      "id": "champion-beer-of-britain",
      "name": "Champion Beer of Britain",
      "category": "camra",
      "summary": "CAMRA's national cask beer competition, judged blind over two years. The 2026 winners were crowned at Cambridge Beer Festival in May. Celebrate the winners and cheer on local finalists.",
      "url": "https://camra.org.uk/awards/champion-beer-of-britain",
      "hashtags": ["#CBOB", "#ChampionBeerOfBritain"],
      "rule": { "kind": "nthWeekday", "month": 5, "weekday": 2, "n": 3, "days": 1, "estimate": true },
      "confirmed": {
        "2026": { "start": "2026-05-19", "end": "2026-05-19", "venue": "Cambridge" }
      },
      "leadDays": 14,
      "drafts": [
        { "id": "finalist", "name": "Local finalist", "phase": "before", "type": "award", "icon": "trophy", "values": { "award": "Champion Beer of Britain", "scope": "Finalist", "result": "", "recipient": "Beer name, Brewery", "year": "{year}", "copy": "🍺 So proud to see [beer] from [brewery] in the final of CAMRA's Champion Beer of Britain {year}!\n\n🤞 Fingers crossed for the big announcement on {start}. Have you tried it yet?\n\n#CBOB #ChampionBeerOfBritain" } },
        { "id": "winner", "name": "Winner crowned", "phase": "start", "type": "award", "icon": "trophy", "values": { "award": "Champion Beer of Britain", "result": "gold", "recipient": "Beer name, Brewery", "year": "{year}", "copy": "🏆 The Champion Beer of Britain {year} has been crowned!\n\n🍺 Huge congratulations to [beer] from [brewery]. Keep an eye out for it on a bar near you.\n\n👏 Well done to every brewery that made the final.\n\n#CBOB #ChampionBeerOfBritain" } }
      ]
    },
    {
      "id": "heritage-open-days",
      "name": "Heritage Open Days",
      "category": "camra",
      "summary": "England's biggest festival of history and culture, ten days every September. A good time to celebrate the historic pub interiors CAMRA's Pub Heritage Group works to protect.",
      "url": "https://www.heritageopendays.org.uk/",
      "hashtags": ["#HeritageOpenDays", "#PubHeritage"],
      "rule": { "kind": "nthWeekday", "month": 9, "weekday": 5, "n": 2, "days": 10, "estimate": true },
      "confirmed": {
        "2026": { "start": "2026-09-11", "end": "2026-09-20" },
        "2027": { "start": "2027-09-10", "end": "2027-09-19" }
      },
      "leadDays": 21,
      "drafts": [
        { "id": "coming-up", "name": "Coming up", "phase": "before", "type": "occasion", "icon": "landmark", "values": { "occasion": "Heritage Open Days", "phase": "countdown", "days": "{days}", "dates": "{dates}", "note": "Historic pubs are heritage too.", "copy": "🏛️ #HeritageOpenDays runs {dates}!\n\n🍺 Historic pubs are heritage too. Why not plan a visit to one of the unspoilt pub interiors on our patch?\n\n#PubHeritage #CAMRA" } },
        { "id": "visit", "name": "Visit a historic pub", "phase": "start", "type": "heritage", "icon": "landmark", "values": { "pubName": "Pub name", "listing": "National Inventory of Historic Pub Interiors", "note": "Raise a glass somewhere with a story this Heritage Open Days, {dates}.", "copy": "🏛️ It's #HeritageOpenDays!\n\n🍺 Pubs are some of our oldest and best loved buildings. [Pub name] is one of the gems on CAMRA's National Inventory of Historic Pub Interiors, so why not raise a glass somewhere with a story?\n\n📍 Find historic pubs near you at pubheritage.camra.org.uk\n\n#PubHeritage #CAMRA" } }
      ]
    },
    {
      "id": "young-members-forum",
      "name": "CAMRA Young Members Forum",
      "category": "camra",
      "summary": "A public national meeting to talk about the issues that matter to CAMRA's young members, with non-members' views welcome too. Saturday 7 November 2026 from 12pm at Attic Brew Taproom, 29b Mary Vale Road, Stirchley, Birmingham B30 2DA. Any branch can share it, any time before the day.",
      "url": "https://camra.org.uk/event/young-members-forum-84213",
      "hashtags": ["#CAMRA", "#CAMRAYoungMembers"],
      "rule": { "kind": "once" },
      "confirmed": {
        "2026": { "start": "2026-11-07", "end": "2026-11-07", "venue": "Birmingham" }
      },
      "leadDays": 21,
      "drafts": [
        { "id": "coming-up", "name": "Coming up", "phase": "anytime", "type": "countdown", "icon": "users", "values": { "event": "CAMRA Young Members Forum", "days": "{days}", "date": "{start}, 12pm", "venue": "Attic Brew Taproom, Stirchley, Birmingham", "copy": "📣 The CAMRA Young Members Forum is coming up!\n\n🗓️ {start}, from 12pm\n📍 Attic Brew Taproom, Stirchley, Birmingham\n\n🍻 A chance to get together and talk about the issues that matter to young members. Not a member yet? Your views are welcome too.\n\n#CAMRA #CAMRAYoungMembers" } },
        { "id": "see-you-there", "name": "Excited to go", "phase": "anytime", "type": "announcement", "icon": "party-popper", "values": { "heading": "See you at the Young Members Forum!", "body": "{start}, from 12pm\nAttic Brew Taproom, Stirchley, Birmingham\nCome and help shape the future of the campaign.", "copy": "🙌 We can't wait for the CAMRA Young Members Forum on {start}!\n\n📍 Attic Brew Taproom, Stirchley, Birmingham, from 12pm.\n\n🍺 Come along, meet young members from across the country and help shape where the campaign goes next. Who's coming with us?\n\n#CAMRA #CAMRAYoungMembers" } },
        { "id": "proud", "name": "Proud to support", "phase": "anytime", "type": "announcement", "icon": "heart", "values": { "heading": "Proud to back our young members", "body": "The future of the campaign is in good hands.\nYoung Members Forum, {start}, Birmingham", "copy": "💛 Proud to see CAMRA putting young members front and centre.\n\n🍻 The Young Members Forum on {start} in Birmingham is a chance for young drinkers to have their say on pubs, pints and the future of the campaign. Members and non-members are welcome.\n\n➡️ Details at camra.org.uk/event/young-members-forum-84213\n\n#CAMRA #CAMRAYoungMembers" } }
      ]
    },
    {
      "id": "tryanuary",
      "name": "Tryanuary",
      "category": "beer",
      "summary": "An independent campaign, running since 2015 and supported by SIBA, that asks people to try a new beer, pub or brewery in January instead of going dry.",
      "hashtags": ["#Tryanuary"],
      "rule": { "kind": "month", "month": 1 },
      "leadDays": 21,
      "drafts": [
        { "id": "on-now", "name": "It's here", "phase": "start", "type": "occasion", "icon": "sparkles", "values": { "occasion": "Tryanuary", "phase": "now", "heading": "Try something new this January", "dates": "{dates}", "note": "Support pubs and breweries through the quietest month: try a new beer, pub or brewery." } }
      ]
    },
    {
      "id": "beer-day-britain",
      "name": "Beer Day Britain",
      "category": "beer",
      "summary": "The UK's national beer day, every 15 June (the day Magna Carta was sealed). The National Cheers to Beer toast is at 7pm.",
      "url": "https://www.beerdaybritain.co.uk/",
      "hashtags": ["#BeerDayBritain", "#CheersToBeer"],
      "rule": { "kind": "fixed", "month": 6, "day": 15 },
      "leadDays": 14,
      "drafts": [
        { "id": "countdown", "name": "Countdown", "phase": "before", "type": "occasion", "icon": "pint", "values": { "occasion": "Beer Day Britain", "phase": "countdown", "days": "{days}", "dates": "{start}", "note": "Join the National Cheers to Beer at 7pm." } },
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "pint", "values": { "occasion": "Beer Day Britain", "phase": "today", "heading": "Cheers to Beer", "dates": "{start}, 7pm", "note": "Raise a glass at your local at 7pm for the National Cheers to Beer." } }
      ]
    },
    {
      "id": "world-cider-day",
      "name": "World Cider Day",
      "category": "beer",
      "summary": "An international day for cider every 3 June, started by German cider houses in 2013.",
      "url": "https://www.worldciderday.com/",
      "hashtags": ["#WorldCiderDay"],
      "rule": { "kind": "fixed", "month": 6, "day": 3 },
      "leadDays": 14,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "apple", "values": { "occasion": "World Cider Day", "phase": "today", "heading": "Happy World Cider Day", "note": "Ask for a real cider or perry at the bar." } }
      ]
    },
    {
      "id": "ipa-day",
      "name": "International IPA Day",
      "category": "beer",
      "summary": "A worldwide day for India pale ale, on the first Thursday of August.",
      "hashtags": ["#IPADay"],
      "rule": { "kind": "nthWeekday", "month": 8, "weekday": 4, "n": 1, "days": 1 },
      "leadDays": 14,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "hops", "values": { "occasion": "International IPA Day", "phase": "today", "heading": "Happy IPA Day", "note": "Which IPA are you raising today?" } }
      ]
    },
    {
      "id": "international-beer-day",
      "name": "International Beer Day",
      "category": "beer",
      "summary": "A worldwide celebration of beer and the people who brew and serve it, on the first Friday of August.",
      "hashtags": ["#InternationalBeerDay"],
      "rule": { "kind": "nthWeekday", "month": 8, "weekday": 5, "n": 1, "days": 1 },
      "leadDays": 14,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "beer", "values": { "occasion": "International Beer Day", "phase": "today", "heading": "Happy International Beer Day", "note": "Raise a glass to the brewers and the bar staff." } }
      ]
    },
    {
      "id": "cask-ale-week",
      "name": "Cask Ale Week",
      "category": "beer",
      "summary": "The industry's annual celebration of cask beer, run by Cask Marque and supported by CAMRA. Ten days in late September (17 to 27 September in 2026).",
      "url": "https://caskaleweek.co.uk/",
      "hashtags": ["#CaskAleWeek"],
      "rule": { "kind": "nthWeekday", "month": 9, "weekday": 4, "n": 3, "days": 11, "estimate": true },
      "confirmed": {
        "2026": { "start": "2026-09-17", "end": "2026-09-27" }
      },
      "leadDays": 28,
      "drafts": [
        { "id": "countdown", "name": "Countdown", "phase": "before", "type": "occasion", "icon": "barrel", "values": { "occasion": "Cask Ale Week", "phase": "countdown", "days": "{days}", "dates": "{dates}", "note": "Celebrate Britain's national drink at your local." } },
        { "id": "on-now", "name": "It's here", "phase": "start", "type": "occasion", "icon": "barrel", "values": { "occasion": "Cask Ale Week", "phase": "now", "heading": "Cask Ale Week", "dates": "{dates}", "note": "Try a pint of cask at one of these pubs.", "pubs": [{ "pub": "Pub name", "detail": "What's on" }, { "pub": "Pub name", "detail": "What's on" }] } },
        { "id": "thanks", "name": "Thank you", "phase": "after", "type": "occasion", "icon": "heart", "values": { "occasion": "Cask Ale Week", "phase": "thanks", "heading": "Thanks for celebrating cask", "note": "Thank you to every pub and brewery that joined in." } }
      ]
    },
    {
      "id": "stout-day",
      "name": "International Stout Day",
      "category": "beer",
      "summary": "A worldwide day for stout and porter, on the first Thursday of November.",
      "hashtags": ["#InternationalStoutDay"],
      "rule": { "kind": "nthWeekday", "month": 11, "weekday": 4, "n": 1, "days": 1 },
      "leadDays": 14,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "mug", "values": { "occasion": "International Stout Day", "phase": "today", "heading": "Happy International Stout Day", "note": "Stout or porter: what is on the bar near you?" } }
      ]
    },
    {
      "id": "small-business-saturday",
      "name": "Small Business Saturday",
      "category": "beer",
      "summary": "The UK's day for supporting small, local businesses, on the first Saturday of December. Independent pubs and breweries are small businesses too.",
      "url": "https://smallbusinesssaturdayuk.com/",
      "hashtags": ["#SmallBizSatUK"],
      "rule": { "kind": "nthWeekday", "month": 12, "weekday": 6, "n": 1, "days": 1 },
      "leadDays": 14,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "store", "values": { "occasion": "Small Business Saturday", "phase": "today", "heading": "Shop small, drink local", "note": "Your local pub is a small business too. Pop in this Small Business Saturday." } }
      ]
    },
    {
      "id": "burns-night",
      "name": "Burns Night",
      "category": "national",
      "summary": "Robert Burns's birthday, 25 January.",
      "rule": { "kind": "fixed", "month": 1, "day": 25 },
      "leadDays": 10,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "utensils", "values": { "occasion": "Burns Night", "phase": "today", "heading": "Happy Burns Night", "note": "Haggis, neeps and a pint of Scottish ale." } }
      ]
    },
    {
      "id": "st-davids-day",
      "name": "St David's Day",
      "category": "national",
      "summary": "The patron saint's day of Wales, 1 March.",
      "rule": { "kind": "fixed", "month": 3, "day": 1 },
      "leadDays": 10,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "flag", "values": { "occasion": "St David's Day", "phase": "today", "heading": "Happy St David's Day", "note": "Raise a glass of Welsh beer or cider at your local." } }
      ]
    },
    {
      "id": "st-patricks-day",
      "name": "St Patrick's Day",
      "category": "national",
      "summary": "The patron saint's day of Ireland, 17 March.",
      "rule": { "kind": "fixed", "month": 3, "day": 17 },
      "leadDays": 10,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "flag", "values": { "occasion": "St Patrick's Day", "phase": "today", "heading": "Happy St Patrick's Day", "note": "Stout, porter or red ale: raise a glass at your local." } }
      ]
    },
    {
      "id": "st-georges-day",
      "name": "St George's Day",
      "category": "national",
      "summary": "The patron saint's day of England, 23 April.",
      "rule": { "kind": "fixed", "month": 4, "day": 23 },
      "leadDays": 10,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "flag", "values": { "occasion": "St George's Day", "phase": "today", "heading": "Happy St George's Day", "note": "Raise a glass of English ale at your local." } }
      ]
    },
    {
      "id": "st-andrews-day",
      "name": "St Andrew's Day",
      "category": "national",
      "summary": "The patron saint's day of Scotland, 30 November.",
      "rule": { "kind": "fixed", "month": 11, "day": 30 },
      "leadDays": 10,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "flag", "values": { "occasion": "St Andrew's Day", "phase": "today", "heading": "Happy St Andrew's Day", "note": "Raise a glass of Scottish ale at your local." } }
      ]
    },
    {
      "id": "international-womens-day",
      "name": "International Women's Day",
      "category": "national",
      "summary": "8 March every year. A day to celebrate the women who brew, pour, run pubs and campaign for them. Breweries often mark it with the International Women's Collaboration Brew Day.",
      "url": "https://www.internationalwomensday.com/",
      "hashtags": ["#InternationalWomensDay", "#IWD{year}"],
      "rule": { "kind": "fixed", "month": 3, "day": 8 },
      "leadDays": 14,
      "drafts": [
        { "id": "today", "name": "On the day", "phase": "start", "type": "occasion", "icon": "sparkles", "values": { "occasion": "International Women's Day", "phase": "today", "heading": "Celebrating women in beer and pubs", "dates": "{start}", "note": "Here's to the women who brew, pour, run our pubs and campaign for them.", "copy": "💜 Happy #InternationalWomensDay!\n\n🍺 Today we're celebrating the women who brew our beer and cider, pour our pints, run our pubs and campaign to keep them thriving.\n\n🙌 Tag a woman in beer or pubs who inspires you.\n\n#IWD{year} #CAMRA" } }
      ]
    },
    {
      "id": "pride-month",
      "name": "Pride Month",
      "category": "national",
      "summary": "June. A month to show that pubs, and CAMRA, are for everyone.",
      "hashtags": ["#PrideMonth", "#Pride{year}"],
      "rule": { "kind": "month", "month": 6 },
      "leadDays": 14,
      "drafts": [
        { "id": "on-now", "name": "Pubs are for everyone", "phase": "start", "type": "occasion", "icon": "heart", "values": { "occasion": "Pride Month", "phase": "now", "heading": "Pubs are for everyone", "dates": "{dates}", "note": "Proud to campaign for pubs where everyone is welcome.", "copy": "🏳️‍🌈 Happy #PrideMonth!\n\n🍻 Pubs are at their best when everyone feels welcome at the bar. We're proud to campaign for pubs, pints and people. All people.\n\n💬 Know a pub that's a brilliant, welcoming space? Give it a shout out below.\n\n#Pride{year} #CAMRA" } }
      ]
    }
  ]
}
